import { Component, Input, ViewEncapsulation } from "@angular/core";
import { DbQueryService } from "@/shared/db-query.service";
import { KpiResult, KpiWidgetBase } from "./kpi-widget-base";

/** count = On-Time Shipped Count (units); value = On-Time Shipped Value (billed dollars). */
export type OnTimeShippedMeasure = "count" | "value";

@Component({
  selector: "app-on-time-shipped-kpi",
  templateUrl: "./on-time-shipped-kpi.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class OnTimeShippedKpiComponent extends KpiWidgetBase {
  @Input() measure: OnTimeShippedMeasure = "count";

  constructor(private dbQueryService: DbQueryService) {
    super();
  }

  protected async fetch(fromDate: string, toDate: string): Promise<KpiResult> {
    const r = await this.dbQueryService.getOnTimeShippedKpi(fromDate, toDate, this.includedAccountIds);
    return this.measure === "value"
      ? { amt: r.onTimeValueAmt, totalAmt: r.totalValueAmt }
      : { amt: r.onTimeUnitCount, totalAmt: r.totalUnitCount };
  }
}
